import { CountryCode } from '@carsys/enums/country-code'
import { OrderSystem } from '@cbgms/api'
import useQuery from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { FormValues } from '../components/Form'
import { loadWholesaler, loadWholesalerServices } from '../state/actions'
import { wholesalerWithServiceKey } from './cache-keys'
import { wholesalerServiceToFieldValues } from './fieldMapper'

export const useGetWholesalerWithServices = (
  UUID: string,
  country?: CountryCode,
  orderSystem?: OrderSystem,
  onSuccess?: (data: FormValues) => void
) => {
  const dispatch = useDispatch()

  return useQuery(
    wholesalerWithServiceKey(UUID, country, orderSystem),
    async () => {
      const { Data: wholesalerData } = await dispatch(loadWholesaler(UUID))
      const { Data: serviceData } = await dispatch(
        loadWholesalerServices(UUID, country || wholesalerData.Country, orderSystem || wholesalerData.OrderSystem)
      )

      return {
        ...wholesalerData,
        ...wholesalerServiceToFieldValues(serviceData)
      }
    },
    { enabled: !!UUID, onSuccess, refetchOnWindowFocus: false }
  )
}
